export default {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  AWS_URL: 'https://woosla-app-storage.s3.amazonaws.com/',
};
